import { http } from './request';
import { AUTH_URLS as API_URLS } from './urls';
import type { AppReportEvent, AppReportEventType } from '../../common/enums/appReport';
import type { AlicomCaptchaSendPayload } from '../utils/alicomCaptcha';

// ========================
// 登录/登出 API
// ========================

const APP_REPORT_REQUEST_TIMEOUT_MS = 2_000;

export interface LoginPayload {
  phone: string;
  code: string;
}

export interface LoginResponseData {
  user_id: string;
  username: string;
  phone: string;
  invitationCode?: string;
  is_admin?: boolean;
}

export interface CurrentUserResponseData {
  user_id: string;
  username: string;
  phone: string;
  invitationCode?: string;
  status?: string;
  is_admin?: boolean;
  create_time?: string | null;
}

export interface SendLoginCodePayload extends Partial<AlicomCaptchaSendPayload> {
  phone: string;
  deviceId?: string;
  requestIp?: string;
  captcha?: Partial<AlicomCaptchaSendPayload>;
}

export interface SendLoginCodeResponse {
  sent: boolean;
  needVerify: boolean;
  captcha?: {
    captchaId?: string;
  };
}

export interface ReportAppEventPayload {
  userId?: string;
  deviceModel: string;
  deviceName: string;
  event: AppReportEvent;
  eventType: AppReportEventType;
  mac?: string;
  os?: string;
  platform?: string;
  arch?: string;
  appVersion?: string;
  buildVersion?: string;
  page: string;
  referrer?: string;
  timestamp: number;
  properties?: Record<string, unknown>;
}

export interface ReportAppEventResponse {
  accepted: boolean;
  eventType: string;
  duplicated: boolean;
}

/**
 * 发送验证码
 */
export const sendLoginCode = (payload: SendLoginCodePayload) => {
  return http.post<SendLoginCodeResponse>(API_URLS.sendLoginCode, payload);
};

/**
 * 登录
 * POST /api/auth/sms-login
 * 成功后服务端下发 Set-Cookie: sid=xxx，浏览器自动存储
 */
export const login = (payload: LoginPayload) => {
  return http.post<LoginResponseData>(API_URLS.login, payload);
};

export const fetchCurrentUser = () => {
  return http.get<CurrentUserResponseData>(API_URLS.currentUser);
};

/**
 * 通用事件上报
 * POST /api/app/report
 */
export const reportAppEvent = (payload: ReportAppEventPayload) => {
  // 埋点请求不能占住页面路由切换和业务接口的连接资源，单独使用短超时降级。
  return http.post<ReportAppEventResponse>(API_URLS.appReport, payload, {
    timeout: APP_REPORT_REQUEST_TIMEOUT_MS,
  });
};

/**
 * 登出
 * POST /api/auth/logout
 * 服务端清除 sid Cookie
 */
export const logout = () => {
  return http.post<null>(API_URLS.logout);
};
